import { Type } from 'class-transformer'
import { EnumEntity } from '..'

import { ContactPerson } from '.'

export class Relationship extends EnumEntity {
  @Type(() => ContactPerson)
  contactPeople: ContactPerson[];
}
